import cn from 'classnames';
import { useRef, type FC } from 'react';
import { getSrcsetString } from 'dibs-image-utils/exports/srcSet.ts';
import { VideoPlayer } from 'dibs-video/exports/VideoPlayer.ts';
import { buildMuxUrl } from 'dibs-video/exports/helpers.ts';

// styles
import dibsCss from 'dibs-css';
import styles from './SbSharedContentModuleLandingVideo.module.css';

export const SbSharedContentModuleLandingVideo: FC<{
    id: string;
    width: number;
    height: number;
    title?: string;
    thumbnailUrl?: string;
    isMuxVideo?: boolean;
}> = ({ id, thumbnailUrl, width, height, title, isMuxVideo }) => {
    const imageOnly = !id && thumbnailUrl;
    const videoPlayerRef = useRef<HTMLVideoElement>(null);

    if (imageOnly) {
        return (
            <img
                alt=""
                sizes="100vw"
                src={thumbnailUrl}
                srcSet={getSrcsetString(thumbnailUrl)}
                style={{ width, height }}
                className={cn(
                    dibsCss.top50,
                    dibsCss.left50,
                    dibsCss.border0,
                    dibsCss.absolute,
                    styles.thumbnail,
                    styles.imageOnly
                )}
            />
        );
    }

    if (isMuxVideo) {
        return (
            <VideoPlayer
                ref={videoPlayerRef}
                fallback={
                    thumbnailUrl && (
                        <img
                            alt=""
                            sizes="100vw"
                            src={thumbnailUrl}
                            srcSet={getSrcsetString(thumbnailUrl)}
                            style={{ width: width, height: height }}
                            className={cn(
                                dibsCss.top50,
                                dibsCss.left50,
                                dibsCss.border0,
                                dibsCss.absolute,
                                styles.thumbnail
                            )}
                        />
                    )
                }
            >
                <VideoPlayer.Media
                    playback={{ autoPlay: true, loop: true, muted: true }}
                    src={buildMuxUrl({ playbackId: id })}
                    objectFit="cover"
                />
            </VideoPlayer>
        );
    }

    return (
        <>
            {thumbnailUrl && (
                <img
                    alt=""
                    sizes="100vw"
                    src={thumbnailUrl}
                    srcSet={getSrcsetString(thumbnailUrl)}
                    style={{ width: width, height: height }}
                    className={cn(
                        dibsCss.top50,
                        dibsCss.left50,
                        dibsCss.border0,
                        dibsCss.absolute,
                        styles.thumbnail
                    )}
                />
            )}
            <iframe
                width={width}
                height={height}
                allow="autoplay"
                className={cn(
                    dibsCss.top50,
                    dibsCss.left50,
                    dibsCss.border0,
                    dibsCss.absolute,
                    styles.iframe
                )}
                title={`${title || ''}_${id.toString()}`}
                referrerPolicy="strict-origin-when-cross-origin"
                src={`https://player.vimeo.com/video/${id}?badge=0&background=1&player_id=0&app_id=143881`}
            />
        </>
    );
};
